/**
 * The simulation's randomness (06 R2): one PCG32 per world. Systems draw from `rngOf(world)`; the
 * world keeps only the generator's state (so it serialises), and `step` writes it back.
 */

import { Pcg32 } from './rng';
import type { World } from './types';

const live = new WeakMap<World, Pcg32>();

export function rngOf(world: World): Pcg32 {
  let r = live.get(world);
  if (!r) {
    r = Pcg32.fromState(world.rng);
    live.set(world, r);
  }
  return r;
}

/** Store the live generator's state back in the world (end of every step). */
export function saveRng(world: World): void {
  const r = live.get(world);
  if (r) world.rng = r.getState();
}

/** An integer in [0, n). */
export const randomInt = (world: World, n: number): number => rngOf(world).int(n);
